module.exports = __webpack_public_path__ + "img/login_top.81032dae.png";